// @ts-ignore
import 'bigint-polyfill';
import React, { useEffect, useState } from 'react';
import { ChakraProvider, Box, extendTheme } from '@chakra-ui/react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from '../Components/Navbar';
import Loader from './Loader';
import Footer from '../Components/Footer';
import Main from '../Components/Main';
import Logo from '../Images/loadinglogo.png';


import { createWeb3Modal, defaultConfig } from '@web3modal/ethers/react';





// Custom Chakra default theme 
const colors = {
  primary: {
    900: '#050405',
    800: '#3A72F3',
    700: '#97C0FA',
    600: '#F9B208',
    500: '#FB5BB9',
    400: '#EB2A64',
    300: '#16A8FB'
  },
  secondary: {
    900: '#01040D',
    800: '#575761',
    700: '#1C1326'
  }
}

const styles = {
  global: {
    'html, body, css': {
      color: 'secondary.800',
      lineHeight: 'tall',
      fontSize: '16px',
      overflow: 'auto',
      Font: 'hacked-kerX',
      background:`#000000`, 
      boxSizing: 'border-box'
    },
    a: {
      fontSize: "20px",
      textDecoration: "none"
    }
  },
}

const breakpoints = {
  sm: '385px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  '2xl': '1536px',
}

const theme = extendTheme({ colors, styles, breakpoints })

const projectId = '0b23d6338fdeed6c3d56b4a7bdb59d63'
const Base = {
  chainId: 8453,
  name: 'Base Chain',
  currency: 'ETH',
  explorerUrl: 'https://basescan.org/',
  rpcUrl: 'https://mainnet.base.org/'
}


const metadata = {
  name: 'Dealix',
  description: 'Dealix',
  url: 'Dealix', 
  icons: [{Logo}]
}

const ethersConfig = defaultConfig({
  metadata,
  autoConnect: true, // Automatically connect to the last used provider
  defaultChain: Base // Set BSC as the default chain


})

createWeb3Modal({
  
  ethersConfig,
  chains: [Base],
  projectId,
  enableInjected: true,
  enableAnalytics: true
})

function App() {
  const [loader, setLoader] = useState(true);
  

  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 5000)
  }, [])

  return loader ? (
    <Loader/>
  ) : (
    
    <ChakraProvider theme={theme} >
      <BrowserRouter>
        <Box px={{base: "8%", md:"12%", lg: "15%"}}>
          <Navbar/>
          <Routes>
            <Route path="/" element={<Main />}/>
          </Routes>
          <Footer/>
        </Box>
      </BrowserRouter>
    </ChakraProvider>
  );
}

export default App;
